/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from 'react';
import { Button } from 'antd';
import { Modal } from 'antd';
import errorNotification from '../../../utils/errorNotification';
import { useTranslation } from 'react-i18next';
import useCustomApiRequest from '../../../custom-hooks/useCustomApiRequest';
import checkRes from '../../../utils/checkRes';
import successNotification from '../../../utils/successNotification';
import UserContext from '../../../contexts/user-context/UserProvider';
import AffiliateContext from '../../../contexts/affiliate-context/AffiliateContext';
import deleteAgentApi from '../../../apis/stores-apis/deleteAgentApi';
import './AffiliateDeleteModal.scss';

const AffiliateDeleteModal = () => {
  const { i18n, t } = useTranslation();
  const { user } = useContext(UserContext);
  const {
    setDeleteAffiliateModalOpened,
    setFetchTableDataCount,
    selectedTableRow,
    setSelectedTableRow,
    deleteAffiliateModalOpened
  } = useContext(AffiliateContext);
  const [isSubmittingForm, setIsSubmittingForm] = React.useState(false);

  const customApiRequest = useCustomApiRequest();
  const handleDelete = () => {
    setIsSubmittingForm(true);
    const formData = new FormData();
    formData.append('agent_id', selectedTableRow?.id);

    customApiRequest(
      deleteAgentApi(formData, user?.token, i18n.language),
      (res) => {
        setIsSubmittingForm(false);
        if (checkRes(res)) {
          setDeleteAffiliateModalOpened(false);
          setSelectedTableRow && setSelectedTableRow(null);
          setFetchTableDataCount((prevState) => prevState + 1);
          successNotification({
            title: t('successTitle'),
            message: res?.data?.message || 'تم الحذف بنجاح'
          });
        } else {
          errorNotification({
            title: t('errorTitle'),
            message: res?.data?.message || 'حاول فى وقت لاحق'
          });
        }
      },
      (error) => {
        setIsSubmittingForm(false);
        errorNotification({
          title: t('errorTitle'),
          message: error?.response?.data?.message || 'حاول فى وقت لاحق'
        });
      }
    );
  };

  const handleCancel = () => {
    setDeleteAffiliateModalOpened(false);
    setSelectedTableRow && setSelectedTableRow(null);
  };

  const sharedT = (key) => t(`deleteModal.${key}`);

  return (
    <Modal
      transitionName=""
      className="affiliate-delete-modal shared-custom-modal shared-delete-modal"
      width="90%"
      style={{ maxWidth: '694px' }}
      // title={<div className="modal-title"></div>}
      title={null}
      open={deleteAffiliateModalOpened}
      onOk={() => {
        setDeleteAffiliateModalOpened(false);
        setSelectedTableRow && setSelectedTableRow(null);
      }}
      onCancel={() => {
        handleCancel();
      }}
      footer={false}
    >
      <div className="modal-content">
        <p>{sharedT('title')}</p>
        <div className="modal-btns">
          <Button
            className="submit-btn"
            onClick={handleDelete}
            type="primary"
            // icon={<LoginOutlined />}
            loading={isSubmittingForm}
          >
            {sharedT('yes')}
          </Button>
          <Button onClick={handleCancel} className="cancel-btn">
            {sharedT('no')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AffiliateDeleteModal;
